import type { QueryFunctionContext, UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import { deserializeExtensionSettings } from "../../services/serialization";
import type { ExtensionSettings } from "../../types";
import { extensionSettingsQueryKeys } from "../key-factory/factory";

export const useExtensionSettingsQuery = (): UseQueryResult<ExtensionSettings | undefined> => {
    return useQuery({
        queryKey: extensionSettingsQueryKeys.settings(),
        queryFn({ signal }: QueryFunctionContext): Promise<string | null> {
            return salesApiService.accountSettings.fetchExtensionDefaults({ cancellation: signal });
        },
        select(rawString: string | null) {
            return rawString != null ? deserializeExtensionSettings(rawString) : undefined;
        },
    });
};
